import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import {
  DataTypeProvider,
  SortingState,
  IntegratedSorting,
  FilteringState,
  RowDetailState,
  IntegratedFiltering,
} from '@devexpress/dx-react-grid'
import {
  Grid,
  VirtualTable,
  TableHeaderRow,
  TableFilterRow,
  TableRowDetail,
} from '@devexpress/dx-react-grid-material-ui';

import TooltipsTypeProvider from './data_type_provider/TooltipsTypeProvider.js';
import MoneyFormat from './format/MoneyFormat.js';

import moment from 'moment';

import firebase from 'firebase/app';
require("firebase/firestore");

const getRowId = row => row.id;

const columns = [
  { name: 'checkInTime', title: 'Check-In' },
  { name: 'checkOutTime', title: 'Check-Out' },
  { name: 'duration', title: 'Duration' },
  { name: 'pass', title: 'Pass' },
  { name: 'paymentAmount', title: 'Payment Amount' },
  { name: 'remark', title: 'Remark' },
];
const columnExtensions = [
  { columnName: 'checkInTime', width: 200 },
  { columnName: 'checkOutTime', width: 200 },
  { columnName: 'duration', width: 70 },
  { columnName: 'pass', width: 100 },
  { columnName: 'paymentAmount', width: 110 },
];

const DateTypeProvider = () => (
  <DataTypeProvider
    for={['checkInTime', 'checkOutTime']}
    formatterComponent={({ value }) => value ? moment(value.toDate()).format('lll') : ''}
  />
);

const DurationTypeProvider = () => (
  <DataTypeProvider
    for={['duration']}
    formatterComponent={({ column, row, value }) =>
      row.checkOutTime ? moment.duration(moment(row.checkOutTime.toDate()).diff(row.checkInTime.toDate())).format("h:mm:ss", { trim: false }) : ''
    }
  />
);

const MoneyTypeProvider = () => (
  <DataTypeProvider
    for={['paymentAmount']}
    formatterComponent={({ value }) => <MoneyFormat displayType='text' value={value} /> }
  />
);

const detailRowTemplate = ({ row }) => <div>id: {row.id}</div>;

class DeskTransactionDialog extends Component {
  state = {
    open: this.props.open,
    rows: [],
  };

  queryDeskTransaction = (userId) => {
    if (userId) {
      firebase.firestore()
        .collection("deskTransaction")
        .where("userId", "==", userId)
        .orderBy("checkInTime", "desc")
        .get()
        .then(querySnapshot => {
          var rows = this.state.rows;
          querySnapshot.docChanges().forEach(function(change) {
            if (change.type === "added" || change.type === "modified") {
              let data = change.doc.data();
              data.id = change.doc.id;

              // pass info
              if (data.passUsed) {
                var found = this.props.passes.find(pass => {return pass.id === data.passUsed});
                data.pass = (found && found.name) || '';
              }

              let index = rows.findIndex(element => {
                return element.id === data.id;
              });
              if (index === -1) {
                rows.push(data);
              } else {
                rows[index] = data;
              }
            }
          }.bind(this));
          this.setState({
            rows: Array.from(rows),
          });
        });
    }
  }

  handleRequestClose = () => {
    this.setState({ open: false });
    this.props.onRequestClose();
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.open !== this.state.open) {
      if (nextProps.open) {
        this.setState({
          open: nextProps.open,
          rows: [],
        });
        this.queryDeskTransaction(nextProps.userId);
      } else {
        this.setState({ open: nextProps.open, });
      }
    }
  }

  render() {
    return (
      <Dialog
        maxWidth="md"
        onClose={this.handleRequestClose}
        open={this.state.open}>
        <DialogTitle>Desk Transactions</DialogTitle>
        <DialogContent style={{ paddingTop: 3 }}>

          <Paper>
            <Grid
              rows={this.state.rows}
              getRowId={getRowId}
              columns={columns}>

              <DateTypeProvider />
              <DurationTypeProvider />
              <MoneyTypeProvider />
              <TooltipsTypeProvider for={['pass', 'remark']} />

              <RowDetailState />

              {/* Sorting */}
              <SortingState
                defaultSorting={[ {columnName: 'checkInTime', direction: 'desc'}, ]} />
              <IntegratedSorting />

              {/* Filter */}
              <FilteringState />
              <IntegratedFiltering />

              <VirtualTable columnExtensions={columnExtensions} />
              <TableHeaderRow showSortingControls />
              <TableFilterRow />
              <TableRowDetail contentComponent={detailRowTemplate} />

            </Grid>
          </Paper>

        </DialogContent>
        <DialogActions>
          <Button onClick={this.handleRequestClose} >Close</Button>
        </DialogActions>
      </Dialog>
    );
  }
}

DeskTransactionDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onRequestClose: PropTypes.func.isRequired,
  passes: PropTypes.array.isRequired,
  userId: PropTypes.string,
};

export default DeskTransactionDialog;
